import FormItem from "components/Form/FormItem";
import { authJsonPost, getUrl } from "functions/BaseAxios";
import { uploadIDImg, uploadSelfieIDImg } from "functions/redux/general/action";
import { RootStore } from "functions/redux/store";
import { checkLogin, getFullCreds } from "functions/redux/user/action";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import 'react-phone-number-input/style.css'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'

export interface PageJoinPartnerProps {
  className?: string;
}
const PageJoinPartner: FC<PageJoinPartnerProps> = ({ className = "" }) => {
  const dispatch = useDispatch();
  const { user, general } = useSelector((state: RootStore) => state);
  const [loading, setLoading] = React.useState("");
  const [name, setName] = React.useState("");
  const [idCard, setIdCard] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState<any>("");
  const [countryNumber, setcountryNumber] = React.useState<any>("");
  const [codeNumber, setcodeNumber] = React.useState<any>("");
  const [bankName, setBankName] = React.useState("");
  const [accountHolder, setAccountHolder] = React.useState("");
  const [swiftCode, setSwiftCode] = React.useState("");
  const [iban, setIban] = React.useState("");
  const { t } = useTranslation();
  const [value, setValue] = React.useState<any | null>(null)
  React.useEffect(() => {
    if (user.credential == null) {
      dispatch(checkLogin());
    }
    // setValue("+6287835730113");
    style();
  })

  const setphoneFormat = (value: any) => {
    if (value !== undefined) {
      let parse = parsePhoneNumber(value);
      if (parse !== undefined) {
        setPhoneNumber(value);
        setcountryNumber(parse.country);
        setcodeNumber(parse.countryCallingCode);
        // console.log(phoneNumber);
        // console.log(value);
        // console.log(parse);
      }

    }
  }

  const style = () => {
    document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("rounded-2xl");
    document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("border-neutral-200");
    document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("font-normal");
    document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("text-sm");
  }

  const renderSidebar = () => {
    return (
      <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
        <Avatar
          hasChecked={user.credential?.isGuide ?? false}
          imgUrl={user.credential?.profile?.avatar}
          hasCheckedClass="w-6 h-6 -top-0.5 right-2"
          sizeClass="w-28 h-28"
        />

        <div className="space-y-3 text-center flex flex-col items-center">
          <h2 className="text-3xl font-semibold">{user.credential?.profile?.displayName}</h2>
        </div>

        <p className="text-neutral-500 dark:text-neutral-400">
          {user.credential?.profile?.aboutMe ?? '---'}
        </p>

        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>
      </div>
    );
  };

  const uploadID = async (event: any) => {
    setLoading("imageID");
    await dispatch(uploadIDImg(event.target.files[0]));
    setLoading("");
  }

  const selfieIDUpload = async (event: any) => {
    setLoading("uploadSelfieID");
    await dispatch(uploadSelfieIDImg(event.target.files[0]));
    setLoading("");
  }

  const submitData = async () => {
    if (loading !== "submit") {
      setLoading("submit");
      try {
        let newData = {
          guideDetail: [{
            agencyName: name,
            bankNumber: accountNumber,
            bankAccountHolder: accountHolder,
            bankName: bankName,
            idCard: general.joinGuide.imageSelfieID,
            idCardNo: idCard,
            idCardSelfie: general.joinGuide.imageID,
            phoneNumber: phoneNumber,
            phoneNumberCountry: countryNumber,
            phoneNumberCode: codeNumber,
            user: user.credential.id,
            swiftNumber: swiftCode,
            iban: iban
          }]
        }

        await authJsonPost(newData);
        dispatch(getFullCreds());
        setLoading("");
      } catch (e) {
        setLoading("");
      }
    }
  }

  const submitData1 = async () => {
    if (loading !== "submit") {
      setLoading("submit");
      try {
        let newData = {
          guideDetail: [{
            phoneNumber: phoneNumber,
            phoneNumberCountry: countryNumber,
            phoneNumberCode: codeNumber,
            user: user.credential.id,
          }]
        }

        var result = await authJsonPost(newData);
        dispatch(getFullCreds());
        setLoading("");
      } catch (e) {
        setLoading("");
      }
    }
  }


  const renderForm1 = () => {
    return (
      <div>
        <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
          <header className="text-center max-w-2xl mx-auto ">
            <h2 className="flex items-center text-lg leading-[115%] md:text-4xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {t('join_partner')}
            </h2>
            <span className="block text-sm mt-2 text-neutral-700 sm:text-sm dark:text-neutral-200">
              {t('thank_you_join')}
            </span>
          </header>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="space-y-8">
            <FormItem
              label={t('phone_number') + "*"}
              desc={t('phone_number_join')}
            >
              {/* <Input placeholder="Phone number" onChange={(e) => setPhoneNumber(e.target.value)} /> */}
              <PhoneInput
                international
                // defaultCountry="ID"
                // onCountryChange={(con) => console.log(con)}
                value={value}
                onChange={phone => {
                  let ph = phone;
                  setValue(phone);
                  // console.log(phone);
                  setphoneFormat(phone);
                  // if (value) {
                  //   console.log(parsePhoneNumber(value));
                  // }
                }}
              />
            </FormItem>

            <ButtonPrimary className="w-full" onClick={submitData1} >
              {loading === "submit" ? <div className="flex justify-center">
                <Loader
                  type="Circles"
                  color="#fff"
                  height={25}
                  width={25}
                />
              </div> : t('send_request_join')}

            </ButtonPrimary>
          </div>
        </div>
      </div>
    )
  }

  const renderForm = () => {
    return (
      <div>
        <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
          <header className="text-center max-w-2xl mx-auto ">
            <h2 className="flex items-center text-lg leading-[115%] md:text-4xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {t('join_partner')}
            </h2>
            <span className="block text-sm mt-2 text-neutral-700 sm:text-sm dark:text-neutral-200">
              {t('thank_you_join')}
            </span>
          </header>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="space-y-8">
            <FormItem
              label={t('name') + "*"}
              desc={t('name_desc')}
            >
              <Input placeholder={t('name')} onChange={(e) => setName(e.target.value)} />
            </FormItem>
            <FormItem
              label={t('phone_number') + "*"}
              desc={t('phone_number_desc')}
            >
              {/* <Input placeholder="Phone number" onChange={(e) => setPhoneNumber(e.target.value)} /> */}
              <PhoneInput
                international
                // defaultCountry="ID"
                // onCountryChange={(con) => console.log(con)}
                value={value}
                onChange={phone => {
                  let ph = phone;
                  setValue(phone);
                  // console.log(phone);
                  setphoneFormat(phone);
                  // if (value) {
                  //   console.log(parsePhoneNumber(value));
                  // }
                }}
              />
            </FormItem>


            <FormItem
              label={t('id_card_') + "*"}
              desc={t('id_card_desc')}
            >
              <Input placeholder="Id card number" onChange={(e) => setIdCard(e.target.value)}
              />
            </FormItem>
            <FormItem
              label={t('bank_name') + "*"}
              desc={t('bank_name_desc')}
            >
              <Input placeholder={t('bank_name')} onChange={(e) => setBankName(e.target.value)} />
            </FormItem>
            <FormItem
              label={t('acc_holder')}
              desc={t('acc_holder_desc')}
            >
              <Input placeholder="Account holder name" onChange={(e) => setAccountHolder(e.target.value)} />
            </FormItem>
            <FormItem
              label={t('swift_code') + "*"}
              desc={t('swift_code_desc')}
            >
              <Input placeholder="Swift Code" onChange={(e) => setSwiftCode(e.target.value)}
              />
            </FormItem>
            <FormItem
              label={t('bank_no') + "*"}
              desc={t('bank_no_desc')}
            >
              <Input placeholder={t('bank_no')} onChange={(e) => setAccountNumber(e.target.value)} />
            </FormItem>
            <FormItem
              label={t('iban')}
              desc={t('iban_desc')}
            >
              <Input placeholder="IBAN" onChange={(e) => setIban(e.target.value)}
              />
            </FormItem>

            <div>
              <div className="mt-5 ">
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    {loading === "imageID" ?
                      <div className="flex mb-2  justify-center">
                        <Loader
                          type="Circles"
                          color="#d24e29"
                          height={25}
                          width={25}
                        />
                      </div>
                      :

                      general.joinGuide.imageID ?
                        <div className={`nc-NcImage h-28 mb-2`}>
                          <img
                            className={`inset-0 w-full h-full object-cover rounded-lg `}
                            src={getUrl(general.joinGuide.imageID)}
                            alt="ID CARD"
                          />
                        </div>
                        :
                        <svg
                          className="mx-auto h-12 w-12 text-neutral-400"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                        >
                          <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                    }
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>{t('upload_image') + "*"}</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        className="sr-only"
                        onChange={(event) => uploadID(event)}
                      />
                    </label>
                    <p className="text-xs text-neutral-500 dark:text-neutral-400">
                      PNG, JPG, GIF (Passport / National ID)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="mt-5 ">
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    {loading === "uploadSelfieID" ?
                      <div className="flex mb-2  justify-center">
                        <Loader
                          type="Circles"
                          color="#d24e29"
                          height={25}
                          width={25}
                        />
                      </div>
                      :

                      general.joinGuide.imageSelfieID ?
                        <div className={`nc-NcImage h-28 mb-2`}>
                          <img
                            className={`inset-0 w-full h-full object-cover rounded-lg `}
                            src={getUrl(general.joinGuide.imageSelfieID)}
                            alt="ID SELFIE CARD"
                          />
                        </div>
                        :
                        <svg
                          className="mx-auto h-12 w-12 text-neutral-400"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                        >
                          <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                    }
                    <label
                      htmlFor="file-upload-selfie"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>{t('upload_image') + "*"}</span>
                      <input
                        id="file-upload-selfie"
                        name="file-upload-selfie"
                        type="file"
                        className="sr-only"
                        onChange={(event) => selfieIDUpload(event)}
                      />
                    </label>
                    <p className="text-xs text-neutral-500 dark:text-neutral-400">
                      PNG, JPG, GIF (Selfie dengan Paspor/ National ID)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-5 mt-3">
          <ButtonPrimary onClick={submitData} >
            {loading === "submit" ? <div className="flex justify-center">
              <Loader
                type="Circles"
                color="#fff"
                height={25}
                width={25}
              />
            </div> : t('submit_app')}

          </ButtonPrimary>
        </div>
      </div>);
  }

  const pendingRegistration = () => {
    return (<div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
      <header className="text-center max-w-2xl mx-auto ">
        <h2 className="flex items-center text-lg leading-[115%] md:text-4xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          GuideSantai Partnership
        </h2>
        <span className="block text-sm mt-2 text-neutral-700 sm:text-sm dark:text-neutral-200">
          {t('waiting_to_request')}
        </span>
      </header>
      <div className="flex justify-end space-x-5 mt-3 justify-center">
        <h3 className="text-primary-6000 font-bold"> {t('waiting')}</h3>
      </div>
    </div>);
  }

  return (
    <div
      className={`nc-PageJoinPartner container pb-24 lg:pb-32 ${className}`}
      data-nc-id="PageJoinPartner"
    >
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
        </div>
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {parseInt(user.credential.isGuide) === 0 && user.credential.guideDetail?.id ? pendingRegistration() : renderForm1()}
        </div>
      </main>
    </div>
  );
};

export default PageJoinPartner;
